var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "51px",
    height: "60px",
    viewBox: "0 0 51 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FB90059A-942F-4BC5-83A5-7EA4EA5E1BE3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "45.-Part-2---How-to-take-Hana-UI",
    transform: "translate(-350.000000, -273.000000)",
    fill: "#4D69A6",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info",
    transform: "translate(350.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4839056,21 C24.0322117,21 23,21.6387107 23,22.5798872 L23,35.3865716 C23,36.1932263 24.0323258,37 25.4839056,37 C26.8709935,37 28,36.1932263 28,35.3865716 L28,22.5798872 C28,21.6387107 26.8709935,21 25.4839056,21 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5153041,13 C24.1042852,13 23,14.1538366 23,15.4824933 C23,16.8111499 24.1042852,18 25.5153041,18 C26.8957148,18 28,16.8111499 28,15.4824933 C28,14.1539604 26.8956063,13 25.5153041,13 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,0 C11.4052237,0 0,11.5251562 0,25.7663672 C0,37.395 7.57268931,47.0506641 17.7824266,50.3299219 L23.5815907,58.9721484 C24.0130044,59.6150391 24.7315249,60 25.5,60 C26.2684796,60 26.9870001,59.6150391 27.4184138,58.9721484 L33.217578,50.3299219 C43.4318357,47.0491406 51,37.3899609 51,25.7663672 C51,11.5161328 39.585624,0 25.5,0 Z M31.1384005,46.0662891 C30.6104346,46.2155859 30.1520141,46.5491016 29.8442754,47.0076563 L25.5000023,53.4815625 L21.1558451,47.0077734 C20.8479905,46.5492188 20.38957,46.2155859 19.861604,46.0664063 C11.1709715,43.6095703 4.63636405,35.5290234 4.63636405,25.7663672 C4.63636405,14.1433594 13.9957922,4.6875 25.5000023,4.6875 C37.0042124,4.6875 46.3636405,14.1433594 46.3636405,25.7663672 C46.3636405,35.53875 39.8194127,43.6122656 31.1384005,46.0662891 Z",
    id: "Shape"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.99f3a81b.svg";
export { ForwardRef as ReactComponent };